import _ from 'underscore';
import Socket, { Message } from '../connection/socket';
import { getState, socketListenerDispatch } from './socket-listener-main';
import * as VideoActions from '../stores/actions/video';
import { GreenroomState } from '../stores/types/types';
import printOTDebugLogForStreamId from '../utils/opentok-debug-helper';
import { Subscriber } from '../utils/video/opentok-connection';
import { OPENTOK_STREAM_AUDIO_ADD_UNMUTED_ID } from '../stores/actions/opentok';

function handleRequestIsLiveState(socket: Socket, message: any) {
	const {
		VideoReducer: {
			isLive,
		},
	} = getState();

	socket.sendMessage('isLive-state-update', { isLive, email: message.message });
	socket.sendMessage('isLive-state-update', { isLive, email: message.message }, `temp-${message.message.toLowerCase()}`);
}

function handleRequestState(socket: Socket, message: any) {
	const {
		VideoReducer: {
			isLive,
		},
		SessionReducer: {
			session,
		},
	} = getState();

	if (session !== message.message) {
		socket.sendMessage('is-live', isLive);
	}
}

function handleTitleToggled({ message }: Message) {
	const {
		SessionReducer: {
			session,
		},
	} = getState() as GreenroomState;

	if (message.from !== session && message.profile) {
		socketListenerDispatch(VideoActions.toggleTitle(message.profile));
	}
}

function handleToggleAllTitles({ message }: Message) {
	const {
		SessionReducer: {
			session,
		},
		ShotsReducer: {
			currentShotId,
			previousShotId,
			shots,
		},
	} = getState() as GreenroomState;

	const [profiles, sentShotId, _session] = message;
	const previousShot = shots.find((shot) => shot.shot_id === previousShotId);
	const currentShot = shots.find((shot) => shot.shot_id === sentShotId);

	if (
		_session === 'beehive'
		&& currentShot
		&& previousShot
		&& currentShot.shot_data.videoTitlesOn
		&& (
			currentShot.shot_data.videoTitlesOn !== previousShot.shot_data.videoTitlesOn
			|| currentShot.shot_id !== previousShot.shot_id
		)
	) {
		socketListenerDispatch(VideoActions.setHiddenTitles([0]));
	} else if (
		_session !== 'beehive'
		&& _session !== session
		&& sentShotId === currentShotId
	) {
		socketListenerDispatch(VideoActions.setHiddenTitles(profiles));
	}
}

export default function Video(socket: Socket) {
	const {
		SessionReducer: {
			host,
		},
	} = getState();

	socket.addListener('toggle-title', handleTitleToggled);
	socket.addListener('toggle-all-titles', handleToggleAllTitles);

	if (host) {
		socket.addListener('request-state', handleRequestState.bind(null, socket));
		socket.addListener('request-isLive-state', handleRequestIsLiveState.bind(null, socket));
	}
}
